export const LIGHT_TCP_STATUS_TYPE = {
  CONNECTED: "connected",
  FAILED: "failed",
  DISCONNECTED: "disconnected",
}

export const SET_LIGHT_TCP_STATUS = "SET_LIGHT_TCP_STATUS";
export const SET_LIGHT_ACTIVE_SESSION = "SET_LIGHT_ACTIVE_SESSION";
